import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { patientPortalAPI } from '../../services/api';

export default function PatientQRLogin() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('رابط غير صالح');
      return;
    }

    const login = async () => {
      try {
        const res = await patientPortalAPI.loginWithQR(token);
        const data = res.data?.data || res.data;

        if (data?.token) {
          localStorage.setItem('patientToken', data.token);
          localStorage.setItem('patientData', JSON.stringify(data.customer));
          setStatus('success');

          // Redirect after brief success message
          setTimeout(() => {
            navigate('/patient/results', { replace: true });
          }, 1500);
        } else {
          throw new Error('Invalid response');
        }
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.message || 'رابط غير صالح أو منتهي الصلاحية');
      }
    };

    login();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">جاري تسجيل الدخول...</h2>
            <p className="text-sm text-gray-500">يرجى الانتظار</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">تم تسجيل الدخول بنجاح!</h2>
            <p className="text-sm text-gray-500">جاري تحويلك لصفحة النتائج...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-lg font-bold text-gray-800 mb-2">فشل تسجيل الدخول</h2>
            <p className="text-sm text-red-500 mb-4">{error}</p>
            <button
              onClick={() => navigate('/patient/login')}
              className="bg-blue-600 text-white px-6 py-2.5 rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors"
            >
              الذهاب لصفحة تسجيل الدخول
            </button>
          </>
        )}
      </div>
    </div>
  );
}
